import { AffiliateContent } from '@fingertip/creator-proto/gen/fingertip/common/type/v1/block_schema_pb'
import { ArrowUpRightIcon, LogoStandaloneIcon } from '@fingertip/icons'
import { useTranslation } from 'react-i18next'

import { BlockAssetInner } from '../shared/block-asset-inner'
import { BlockProps } from '../shared/block-switch'

export const AffiliateBlock = ({
  block,
  handleClick,
  h,
  w,
  y,
  scaleFactor,
}: BlockProps) => {
  const { t } = useTranslation()
  const content = block?.content?.content?.value as AffiliateContent

  return (
    <a
      className="relative flex size-full"
      href={content?.websiteUrl}
      onClick={() => handleClick?.(block, `${content?.title}`)}
      target="_blank"
    >
      <BlockAssetInner
        title={content?.title || t('affiliate_title')}
        description={content?.description || t('affiliate_description')}
        icon={<LogoStandaloneIcon className="size-fluid-4" />}
        buttonText={content?.buttonText || t('affiliate_button_text')}
        w={w}
        h={h}
        y={y}
        buttonIcon={<ArrowUpRightIcon className="size-fluid-4 shrink-0" />}
        scaleFactor={scaleFactor}
      />
    </a>
  )
}
